<div class="clearfix">
  <div class="float-start text--small margin-top-bottom--1x">
    Visar {{rangeStart}} - {{rangeEnd}} av {{pagination.total}}
  </div>
  <nav class="float-end" aria-label="Paginering" *ngIf="pagination.last > 1">
    <button
      class="woo-pagination woo-pagination--nav {{css}}"
      type="button"
      aria-label="Föregående sida"
      [disabled]="pagination.page <= 1"
      (click)="requestPage(pagination.page - 1)"
    >‹</button>
    <ng-container *ngFor="let item of items; trackBy: trackByItem">
      <button
        *ngIf="item.kind === 'page'"
        class="woo-pagination {{css}}"
        type="button"
        [ngClass]="{active: pagination.page === item.number}"
        [attr.aria-current]="pagination.page === item.number ? 'page' : null"
        (click)="requestPage(item.number)"
      >{{item.number}}</button>
      <span
        *ngIf="item.kind === 'gap'"
        class="woo-pagination__gap"
        [title]="'Sida ' + item.from + ' - ' + item.to"
      >…</span>
    </ng-container>
    <button
      class="woo-pagination woo-pagination--nav {{css}}"
      type="button"
      aria-label="Nästa sida"
      [disabled]="pagination.page >= pagination.last"
      (click)="requestPage(pagination.page + 1)"
    >›</button>
  </nav>
</div>
